module.exports = __webpack_public_path__ + "img/graph.77a40395.jpg";